<script>
import {mapActions} from "pinia";
import {orgProfileStore} from "@/store/orgProfileStore";
import InfiniteLoadingLoader from "@/components/InfiniteLoadingLoader.vue";
import NewsItem from "@/components/News/NewsItem.vue";
import BaseNoResultMessage from "@/components/BaseNoResultMessage.vue";


export default {
  name: "OrgProfileProposalsList",
  props: {
    orgId: {
      type: Number
    }
  },
  components: {
    InfiniteLoadingLoader,
    NewsItem,
    BaseNoResultMessage
  },
  data() {
    return {
      loadPageCount: 10,
      pageNumber: 1,
      profileNewsItems: []
    };
  },
  computed: {
    profileId() {
      return this.$route.params.id;
    },
    loadParams() {
      return {
        "page.page": this.pageNumber,
        "page.size": this.loadPageCount,
        id: this.profileId
      };
    },
  },
  methods: {
    ...mapActions(orgProfileStore, [
      'getOrgProfileNews'
    ]),
    getNews($state) {
      this.getOrgProfileNews(this.loadParams).then((resp)=> {
        if (resp.data.length > 0) {
          this.profileNewsItems = this.profileNewsItems.concat(resp.data);
          this.pageNumber += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    },
    infiniteHandler($state) {
      if ($state) {
        this.getNews($state);
      }
    }
  },
  beforeUnmount() {
    this.loadPageCount = [];
  }
}
</script>

<template>
  <div>
    <news-item v-for="item in profileNewsItems"
               :key="item.id"
               :item-data="item"
    />
    <infinite-loading @infinite="infiniteHandler">
      <template #spinner>
        <InfiniteLoadingLoader/>
      </template>
      <template #no-results>
        <base-no-result-message :text="$t('common.noResults')"/>
      </template>
    </infinite-loading>
  </div>
</template>
